import React from 'react';
import {defineMessages} from 'react-intl';
import {useLocation} from 'react-router';
import {useInitBreadcrumbs} from '@igp/shared/components/breadcrumb';
import {ErrorModal} from '@igp/shared/components/error';
import {LayoutDetails, LayoutDetailsHeader} from '@igp/shared/components/layout';
import {defaultIdQueryFilterKey} from '@igp/shared/components/link';
import {withTraceErrorBoundary} from '@igp/shared/otel';
import {getValueFromQueryFilter} from '@igp/shared/utils';

import {PlayerFinancialInfo, PlayerMarketingInfo, PlayerPersonalInfo} from '@features/shared-blocks';

const localized = defineMessages({
    title: {
        id: 'PlayerDetails_header',
        defaultMessage: 'Player Details',
    },
});

function PlayerDetailsInner() {
    const search = useLocation().search;
    const uid = getValueFromQueryFilter<typeof defaultIdQueryFilterKey, string>(search, defaultIdQueryFilterKey);

    useInitBreadcrumbs([
        {
            url: undefined,
            title: localized.title,
            clickable: false,
        },
        {
            url: uid,
            title: uid,
            clickable: false,
        },
    ]);

    return (
        <LayoutDetails
            header={<LayoutDetailsHeader />}
            primaryInfo={
                <>
                    <PlayerPersonalInfo uid={uid} />
                    <PlayerFinancialInfo uid={uid} />
                    <PlayerMarketingInfo uid={uid} />
                </>
            }
            secondaryInfoTop={null}
            secondaryInfoBottom={null}
        />
    );
}

export const PlayerDetails = withTraceErrorBoundary(PlayerDetailsInner, ErrorModal);
